import { APP_CONFIG } from '@/constants/app';
import { Subscription } from '@/types/auth.types';
import {
  ApiResponse,
  CheckoutRequest,
  CheckoutSession,
  Invoice,
  Plan,
} from '@/types/payment.types';
import { tokenManager } from '@/utils/token-manager';
import axios from 'axios';

// Create axios instance for payment service
const paymentApi = axios.create({
  baseURL: APP_CONFIG.api.baseUrl + '/payments',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Setup automatic token refresh interceptors
tokenManager.setupInterceptors(paymentApi);

export const paymentService = {
  // Plans
  getPlans: async (): Promise<ApiResponse<Plan[]>> => {
    const response = await paymentApi.get<ApiResponse<Plan[]>>('/plans');
    return response.data;
  },

  // Stripe Checkout Session
  createCheckoutSession: async (
    data: CheckoutRequest
  ): Promise<ApiResponse<CheckoutSession>> => {
    const response = await paymentApi.post<ApiResponse<CheckoutSession>>(
      '/checkout',
      data
    );
    return response.data;
  },

  getCurrentSubscription: async (): Promise<ApiResponse<Subscription>> => {
    const response =
      await paymentApi.get<ApiResponse<Subscription>>('/subscription');
    return response.data;
  },

  cancelSubscription: async (): Promise<ApiResponse<{ message: string }>> => {
    const response = await paymentApi.post<ApiResponse<{ message: string }>>(
      '/subscription/cancel'
    );
    return response.data;
  },

  // Invoices
  getInvoices: async (): Promise<ApiResponse<Invoice[]>> => {
    const response = await paymentApi.get<ApiResponse<Invoice[]>>('/invoices');
    return response.data;
  },

  downloadInvoice: async (invoiceId: string): Promise<Blob> => {
    const response = await paymentApi.get(`/invoices/${invoiceId}/download`, {
      responseType: 'blob',
    });
    return response.data;
  },
};
